<template lang="pug">
  router-link#book-now(v-if="bookingButton.linkEntry" :to="bookingButton.linkEntry" :class="color")
    span(:class="booking ? 'hide' : 'show'" v-html="bookingButton.label")
  a#book-now(v-else-if="bookingButton.linkUrl" :href="bookingButton.linkUrl" target="_blank" rel="noreferrer" :class="color")
    span(:class="booking ? 'hide' : 'show'" v-html="bookingButton.label")
</template>

<script>
import debug from 'debug'
import { mapActions, mapState } from 'vuex'

let log = debug('component:BookingButton')

export default {
  name: 'bookingButton',
  props: {
    open: Boolean,
    color: String,
    closedButton: Boolean,
    bookingButton: {
      type: Object,
      required: true,
    },
  },
  data () {
    return {
      buttonColor: this.$route.meta.menuColor,
      buttonTextColor: '',
    }
  },
  watch: {
    $route (to, from) {
      this.buttonColor = this.$route.meta.menuColor
    },
    open () {
      return this.open
    },
  },
  mounted () {
    log('Mounted')

    if (window.innerWidth >= 768) {
      if (this.buttonColor === 'dark') {
        this.buttonColor = '#2a2423'
        this.buttonTextColor = '#f6eeeb'
      } else {
        this.buttonColor = '#f6eeeb'
        this.buttonTextColor = '#2a2423'
      }
    }
  },
  computed: {
    ...mapState('menu', ['booking', 'menuState']),
  },
  methods: {
    ...mapActions('menu', ['bookingToggle']),
    detectIE () {
      var ua = window.navigator.userAgent
      var msie = ua.indexOf('MSIE ')
      if (msie > 0) {
        // IE 10 or older => return version number
        return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10)
      }

      var trident = ua.indexOf('Trident/')
      if (trident > 0) {
        // IE 11 => return version number
        var rv = ua.indexOf('rv:')
        return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10)
      }

      return false
    },
    bookingModal (open) {
      if (this.booking) return
      if (this.detectIE()) {
        window.open('http://mews.li/distributor/02945ba6-727d-403b-8e7a-aacb009d7df6', '_blank')
      } else {
        this.bookingToggle(!open)
      }
    },
  },
  components: {
  },
}
</script>

<style scoped lang="scss">
#book-now {
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: all;
  color: $black;
  background: $cream;
  position: absolute;
  right: 8px;
  bottom: 35px;
  text-align: center;
  text-transform: uppercase;
  text-decoration: none;
  width: 100px;
  height: 100px;
  border: $cream;
  border-radius: 50%;
  transition: all 0.3s ease;
  margin-top: 5px;
  font-family: 'Martha Black';
  font-size: 18px;

  @media #{$mobile} {
    width: 60px;
    height: 56px;
    font-size: 14px;
    position: fixed;
    top: -6px;
    right: 23px;
    bottom: auto;
    padding: 0;
    color: $violent-sunset;
    background: transparent;
  }

  span {
    display: block;
    opacity: 0;

    &.show {
      opacity: 1;
      transition: opacity 0.5s ease 0.9s;
    }

    @media #{$mobile} {
      margin: 0px;
    }
  }

  &:hover {
    cursor: pointer;
    text-decoration: none;
    background: $violent-sunset;
    @media #{$mobile} {
      background: transparent;
    }
  }

  &.open {
    &.booking {
      background: red;
      // animation: animateButtonMenuOpen 1s ease forwards;
    }
  }

  &.animate-button {
    animation: animateButton 1.8s ease;

    @media #{$mobile} {
      animation: animateMobileButton 1.8s ease;
    }
  }

  &.close-button {
    animation: closeButton 1s ease;

    @media #{$mobile} {
      animation: closeMobileButton 1s ease;
    }
  }
}

/***************** Button animtaion - Menu Closed ***********************/

@keyframes animateButton {
  0% {
    background: $violent-sunset;
  }

  90% {
    transform: scale(70);
    background: $violent-sunset;
  }

  100% {
    background: $cream;
  }
}

@keyframes closeButton {
  0% {
    background: $violent-sunset;
    color: $violent-sunset;
    transform: scale(70);
  }

  90% {
    background: $violent-sunset;
  }

  99% {
    transform: scale(1);
  }
}

/***************** Button animtaion - Menu Open ***********************/

@keyframes animateButtonMenuOpen {
  0% {
    position: fixed;
    right: 3vw;
    color: $black;
    background: $violent-sunset;
  }
  5% {
  }

  90% {
    color: $black;
    transform: scale(70);
  }

  100% {
    color: $violent-sunset;
    background: $violent-sunset;
  }
}

/***************** Button animtaion - Mobile ***********************/

@keyframes closeMobileButton {
  0% {
    background: $violent-sunset;
    color: $violent-sunset;
    transform: scale(70);
  }

  90% {
    background: $cream;
    color: $cream;
  }

  100% {
    transform: scale(1);
    color: $violent-sunset;
  }
}

@keyframes animateMobileButton {
  0% {
    background: $violent-sunset;
    color: $violent-sunset;
  }

  90% {
    background: $violent-sunset;
    color: $violent-sunset;
    transform: scale(30);
  }

  100% {
    background: transparent;
  }
}

</style>
